import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import BackIcon from "@mui/icons-material/ArrowBack";
import ReloadIcon from "@mui/icons-material/Refresh";
import MainPageIcon from "@mui/icons-material/Home";

type ErrorViewProps = {
  errorMessage?: string;
};

const ErrorView = ({ errorMessage }: ErrorViewProps): ReactElement => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        paddingTop: 16,
      }}
    >
      <Typography variant="h4">Something is wrong :(</Typography>
      <Typography variant="body1">
        {errorMessage && errorMessage.toString()}
      </Typography>
      <ButtonGroup
        size="large"
        color="primary"
        aria-label="Error page actions"
        variant="text"
        sx={{ marginTop: 16, maxWidth: "100%" }}
      >
        <Button
          onClick={() => {
            navigate(-1); // equivalent of v5 history.goBack()
          }}
          startIcon={<BackIcon></BackIcon>}
        >
          Back
        </Button>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          startIcon={<ReloadIcon></ReloadIcon>}
        >
          Reload
        </Button>
        <Button
          component={Link}
          to="/"
          startIcon={<MainPageIcon></MainPageIcon>}
        >
          Main Page
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default ErrorView;
